import React from 'react'
import styles from './add-remove-player-from-watchlist.module.scss'
import i18n from 'constants/strings'
import classNames from 'classnames'
import { WtnColorsEnum } from 'types/global'
import WatchlistBadge from './WatchlistBadge'

export interface AddRemovePlayerFromWatchListProps {
  inWatchlist?: boolean
  onAddPlayer?: () => void
  onRemovePlayer?: () => void
  isDisabled?: boolean
  hasText?: boolean
  color?: WtnColorsEnum
}

const AddRemovePlayerFromWatchList = ({
  inWatchlist = false,
  onAddPlayer,
  onRemovePlayer,
  isDisabled,
  hasText = false,
  color = WtnColorsEnum.PRIMARY_ALT,
}: AddRemovePlayerFromWatchListProps) => {
  const handleClick = inWatchlist ? onRemovePlayer : onAddPlayer
  const text = inWatchlist
    ? i18n.t('strProfileHeader.removeFromWatchlist')
    : i18n.t('strProfileHeader.addToWatchlist')
  return (
    <button
      className={classNames(styles.addRemoveBtn, 'profile-watchlist', {
        [styles.disabledBtn]: isDisabled,
        [styles.withText]: hasText,
      })}
      onClick={handleClick}
      disabled={isDisabled}
      aria-label={
        inWatchlist
          ? i18n.t('strCommonUI.ariaLabel.watchlistIncludedBtn')
          : i18n.t('strCommonUI.ariaLabel.watchlistNotIncludedBtn')
      }
    >
      <WatchlistBadge isMember={inWatchlist} color={color} />
      {hasText && <span className={styles.btnText}>{text}</span>}
    </button>
  )
}

export default AddRemovePlayerFromWatchList
